import request, {requestJson} from '../main';
const service = ""
class SysNoticeApi {
    private url: string = service + "/sys-notice";
    public page(args: any){
        return request({
            url: this.url + '/page',
            method: 'get',
            params: args
        })
    }

    public edit(data: any){
        return requestJson({
            url: this.url + '/edit',
            method: 'post',
            data: data
        })
    }

    public get(id: number){
        return request({
            url: this.url + '/get',
            method: 'get',
            params: {
                id: id
            }
        })
    }

    public batchDelete(ids: string){
        return request({
            url: this.url + '/batch-delete',
            method: 'delete',
            params: {
                ids: ids
            }
        })
    }

    public batchPublishOrRecall(ids: string, status: number){
        return request({
            url: this.url + '/batch-publish-or-recall',
            method: 'post',
            data: {
                ids: ids,
                status: status
            }
        })
    }

    public listPublishNotice(){
        return request({
            url: this.url + '/list-publish-notice',
            method: 'get'
        })
    }

}
const sysNoticeApi = new SysNoticeApi();
export {sysNoticeApi}
